// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BHNWyyxddKs6Cqx9Cs8R{border:0;padding:0}.lmg8tPkT9FYcsPyykuVq{border:0;border-bottom:1px solid var(--border-neutral-default);padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"virtualRowSpacer": `BHNWyyxddKs6Cqx9Cs8R`,
	"virtualRowSkeletonCell": `lmg8tPkT9FYcsPyykuVq`
};
export default ___CSS_LOADER_EXPORT___;
